export default class Role {
	constructor({added_on, description, id, name, update_on, alias}) {
		this.added_on = added_on || "";
		this.description = description || "";
		this.id = id || 0;
		this.name = name || "";
		this.update_on = update_on || "";
		this.alias = alias || this.name;
	}
}
